module.exports = __webpack_public_path__ + "img/vmc_office_logo-7-7-2021.71a78a69.jpg";